import ButtonBase from '@material-ui/core/ButtonBase';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import EllipsesIcon from '~/components/icons/EllipsesIcon';

import styles from './SettingsMenu.style';

class SettingsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      anchor: null,
    };
  }

  UNSAFE_componentWillReceiveProps({ open }) {
    this.setState({ open });
  }

  onShowSettingsPopup = (event) => {
    this.setState({
      open: true,
      anchor: event.currentTarget,
    });
  };

  onCloseSettingsPopup = () => {
    this.setState({
      open: false,
      anchor: null,
    });
  };

  render() {
    const { children, classes } = this.props;
    const { open, anchor } = this.state;

    return (
      <>
        <ButtonBase
          classes={{ root: classes.buttonRoot }}
          ref={(menuButton) => (this.menuButton = menuButton)}
          onClick={this.onShowSettingsPopup}>
          <EllipsesIcon height={39} />
        </ButtonBase>

        <Menu anchorEl={anchor} open={open} onClose={this.onCloseSettingsPopup}>
          {children}
        </Menu>
      </>
    );
  }
}

SettingsMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.arrayOf(withStyles(MenuItem)).isRequired,
  open: PropTypes.bool,
  squareIcon: PropTypes.bool,
};

SettingsMenu.defaultProps = {
  open: false,
  squareIcon: false,
};

export default withStyles(styles)(SettingsMenu);
